import TextSeasonEpisode from './TextSeasonEpisode'

export default TextSeasonEpisode
// eslint-disable-next-line import/export
export * from './TextSeasonEpisode'
